import { applyThemeForSetting, getSystemTheme } from '@up2stay/up2promo-ui';
import { useEffect } from 'react';

const THEME_COLOR = {
  light: '#ececec',
  dark: '#1a1a1a',
} as const;

function syncThemeColor() {
  const meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) return;
  meta.setAttribute('content', THEME_COLOR[getSystemTheme()]);
}

/**
 * Always follows the OS color scheme. No persisted preference or switcher.
 */
export function useThemeBootstrap() {
  useEffect(() => {
    applyThemeForSetting('system');
    syncThemeColor();

    if (typeof window === 'undefined') return;

    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => {
      applyThemeForSetting('system');
      syncThemeColor();
    };
    media.addEventListener('change', handleChange);
    return () => media.removeEventListener('change', handleChange);
  }, []);
}
